export function errorDetail(error: any): string {
  if (!error) {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  const respData = error.response && error.response.data;
  if (respData) {
    if (typeof respData === 'string') {
      return respData;
    }
    if (respData.message || respData.error || respData.detail) {
      return String(respData.message || respData.error || respData.detail);
    }
  }
  return error.message || error.error || String(error);
}
